/**
 * @file: 多个卧柜布局
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../cubeTree';
import Utils from '../../utils/util';
import { layerCubeSize } from '../size';
import { cubeModify } from '../../update/cubeModify';
import { makeSkuCubesColGroupList } from './groupList';

export function cabinetsLayout(cabinets: CubeId[], startLeft: PhysicsMeasurement = 0): void {
    cabinets.forEach((cabinet: CubeId): void => {
        cabinetLayout(cabinet, startLeft);
    });
}

function cabinetLayout(cabinet: CubeId, startLeft: PhysicsMeasurement): void {
    let startX: PhysicsMeasurement = startLeft;
    let startY: PhysicsMeasurement = 0;
    let children: CubeId[] = CubeTree.findChildCubeIds(cabinet);
    let colWidth: PhysicsMeasurement = Number.MIN_VALUE;
    let cols: CubeId[][] = makeSkuCubesColGroupList(children);

    for (let i = 0; i < cols.length; i++) {
        let col: CubeId[] = cols[i];

        colWidth = Number.MIN_VALUE;
        for (let j = 0; j < col.length; j++) {
            let cubeId: CubeId = col[j];
            let layoutCubeSize: PhysicsSize = layerCubeSize(cubeId);

            colWidth = Math.max(colWidth, layoutCubeSize.width);
            cubeModify(cubeId, {
                posX: startX,
                posY: startY
            });
            startY = Utils.math(startY, layoutCubeSize.height, '+');
        }
        startX = Utils.math(startX, colWidth, '+');
        startY = 0;
    }
}
